export default __webpack_public_path__ + "static/media/ht.1aa7bd09.svg";